// @flow
import { connect } from 'react-redux'
import IncludedVkAppsTextArea from './IncludedVkAppsTextArea'
import type { Store } from '../../redux/ducks'
import _ from 'lodash'
import { patch } from '../AudienceEditContainer'
import type { GroupedStringParameters } from '../types'
import * as segmentationReducer from '../../redux/ducks/segmentation/reducers'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit
  const initial = audienceState.initial

  if (!initial) return {}

  return {
    errors: audienceState.includedVkAppsErrors,
    includedVkAppsGroups: audienceState.includedVkAppsGroups
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onIncludedVkAppsGroupAdd: () => {
      dispatch(segmentationReducer.patch({ segmentByVkApps: true }))
      patch(dispatch, { useVkAppsGroupNames: true })
    },
    onIncludedVkAppsGroupRemove: (includedVkAppsGroups: Array<GroupedStringParameters>) => {
      patch(dispatch, { useVkAppsGroupNames: includedVkAppsGroups.length > 1 })
    }
  }
}

const IncludedVkAppsTextAreaContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(IncludedVkAppsTextArea)

export default IncludedVkAppsTextAreaContainer
